$(document).ready(() => {
  const storeList = $('.store-container');

  $(window).bind('pageshow', function (event) {
    if (event.originalEvent.persisted) {
      window.location.reload();
    }
  });

  storeList.on('click', function (e) {
    storeList.each((i, el) => {
      const curEl = $(el);
      const selectedEl = $(this);
      const viewDetailButton = $('#btn-view-detail');

      if (curEl.attr('id') !== selectedEl.attr('id')) return curEl.addClass('hidden');

      selectedEl.css({ 'border-bottom': '2px solid #FF90B0' });
      viewDetailButton.removeClass('hidden').attr('href', selectedEl.find('a').attr('href'));
    });
  });
});
